import CertificateWebPageEn from './CertificateWebPageEn';
export default CertificateWebPageEn;
